export default __webpack_public_path__ + "static/media/PoliticaLecca.070a82bd.pdf";